import { render, staticRenderFns } from "./SectorCard.vue?vue&type=template&id=fe0b9f0c&"
import script from "./SectorCard.vue?vue&type=script&lang=js&"
export * from "./SectorCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports